import { ContactUrl } from "kz-ui-sdk";
import { EVENT_CLOSE_CONTACT_LINKS_DIALOG, EVENT_OPEN_CONTACT_LINKS_DIALOG } from "./constants";

export interface ContactLinksDialogOption {
  callback?: () => void;
  contactLinks?: ContactUrl[];
}

export const openContactLinksDialog = (options: ContactLinksDialogOption = {}) => {
  const event = new CustomEvent(EVENT_OPEN_CONTACT_LINKS_DIALOG, {
    detail: options,
  });
  window.dispatchEvent(event);
};

export const closeContactLinksDialog = () => {
  const event = new CustomEvent(EVENT_CLOSE_CONTACT_LINKS_DIALOG);
  window.dispatchEvent(event);
};
